import { Injectable, inject } from "@angular/core";
import { DashboardsService, HelpersService } from "../shared";
import { ITranslateObject, TaxprepT1Card } from "../views-interfaces";
import { CheckModel } from "./filter-types";

@Injectable({
    providedIn: "root",
})
export class DeadlineFilterGeneratorService {
    private readonly dashboardsService = inject(DashboardsService);
    private readonly helpersService = inject(HelpersService);

    constructor() {}

    generateApril30thModel(selection: boolean) {
        return {
            label: "FiltersSidebar.Options.Deadline.April30th",
            selected: selection,
        } as CheckModel;
    }

    generateJune15thModel(selection: boolean) {
        return {
            label: "FiltersSidebar.Options.Deadline.June15th",
            selected: selection,
        } as CheckModel;
    }

    getPrintDescription(
        label: string | ITranslateObject,
        hasApril30th: boolean,
        hasJune15th: boolean,
    ): { label: string | ITranslateObject; values: string[] } | null {
        if (!hasApril30th && !hasJune15th) {
            return null;
        } else {
            const values: string[] = [];
            if (hasApril30th) {
                values.push("FiltersSidebar.Options.Deadline.April30th");
            }
            if (hasJune15th) {
                values.push("FiltersSidebar.Options.Deadline.June15th");
            }
            return {
                label,
                values,
            };
        }
    }

    async generateFilter(hasApril30th: boolean, hasJune15th: boolean) {
        if (!hasJune15th && !hasApril30th) {
            return null;
        }
        const currentDashboard = await this.dashboardsService.getCurrentDashboard();
        const databaseName = currentDashboard?.DatabaseName || "";
        const currentDashboardYear = databaseName.split("dashboard");
        const yearToFilter = Number.parseInt(currentDashboardYear[1], 10) + 1;
        const deadlineApril = this.helpersService.convertMillisecondsToSeconds(new Date(yearToFilter, 3, 30, 23, 59, 59).getTime());
        const deadlineJune = this.helpersService.convertMillisecondsToSeconds(new Date(yearToFilter, 5, 15, 23, 59, 59).getTime());

        return (card: TaxprepT1Card) => {
            const deadline = card.dateNeeded || card.deadLine;

            if (hasApril30th && hasJune15th) {
                return deadline <= deadlineApril || (deadline > deadlineApril && deadline <= deadlineJune);
            } else if (hasJune15th) {
                return deadline > deadlineApril && deadline <= deadlineJune;
            } else if (hasApril30th) {
                return deadline <= deadlineApril;
            } else {
                return false;
            }
        };
    }
}
